import { SocketClient } from '~/data/protocols/socket';
import { LeftWaitingRoom } from '~/domain/usecases/waitingRoom/socket';

export class SocketLeftWaitingRoom implements LeftWaitingRoom {
  private readonly event: string;

  private readonly SocketClient: SocketClient<any>;

  constructor(event: string, socketClient: SocketClient<any>) {
    this.event = event;
    this.SocketClient = socketClient;
  }

  left = async (
    params: LeftWaitingRoom.Params,
    fallback?: Function,
  ): Promise<void> => {
    const SocketResponse = await this.SocketClient.emit({
      event: this.event,
      body: params,
    });

    if (fallback) fallback(SocketResponse.body);
    return SocketResponse.body;
  };
}
